Librarian.Modules.Image = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-image-",
        imagePath: null,
        fromLibrary: null, 
        alt: null,
        onClick: null,
        onPostRender: null, 
        link: null,
        label: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || !this.options.imagePath)
            return;

        // get path in library
        var path = this.options.imagePath;
        if (this.options.fromLibrary)
            path = Librarian.path.getLibraryPath() + path;

        this.parent();

        // destroy old container element
        if (this.containerEl) {
            $(this.containerEl).destroy();
            this.containerEl = null;
        }

        // build image element
        var imageEl = new Element("img", {
            "class": (this.options.classPrefix || '') + "image",
            "alt": this.options.alt || '',
            "src": path
        }).injectInside(this.wrapperEl);

        //add label if specified
        if(this.options.label){
            var labelEl = new Element("span",{
                "class": (this.options.classPrefix || '') + "label"
            }).injectInside(this.wrapperEl);
            labelEl.set("text", this.options.label);
        }

        // if link to open specified
        if(this.options.link) {
            var self = this;
            this.options.onClick = function() {
                var newtab = window.open(self.options.link, '_blank');
                newtab.focus();
            };
            imageEl.setStyles({"cursor": "pointer"});
        }

        // add click handler
        if(typeof this.options.onClick == "function") {
            imageEl.addOnClick(this.options.onClick);
        }

        // call postrender callback
        if (this.options.onPostRender)
            this.options.onPostRender(this.wrapperEl, this.options.onClick);

    }
});